import { motion } from "framer-motion";

export default function PageHeader({ eyebrow, title, intro, children }) {
  return (
    <section className="pt-32 md:pt-40 pb-16 md:pb-24 border-b border-[#D2D0C9] bg-[#F6F5F2]">
      <div className="container-fz">
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="eyebrow mb-5"
        >
          {eyebrow}
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.05 }}
          className="font-display text-4xl sm:text-5xl lg:text-6xl text-stone-900 max-w-4xl"
        >
          {title}
        </motion.h1>
        {intro && (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="mt-6 text-base md:text-lg text-stone-600 max-w-2xl leading-relaxed"
          >
            {intro}
          </motion.p>
        )}
        {children}
      </div>
    </section>
  );
}
